export enum MapSettingsToolsStateActiveTool {
  Boundary = 'boundary',
  DataLayers = 'dataLayers',
}

export type MapSettingsToolsStateActiveToolState = MapSettingsToolsStateActiveTool | null;
